import React from "react";
import "./About.css";

const About = () => {
    return (
        <section id="about" className="about">
            <div className="about-content">
                <h2>About Us</h2>
                <p>
                    Every great success story begins with a vision and a spark of determination. The story of Kapra Group is no different, founded in 2022 by two dynamic young entrepreneurs, Kannan Thilakan and Prasob Das , who dared to dream big and work tirelessly to bring their vision to life.
                    <br />
                    The name Kapra itself is a testament to their partnership and mutual respect, derived from the combination of "Ka" from Kannan and "Pra" from Prasob, symbolizing the harmony of their skills, ideas, and aspirations. But their journey to establish Kapra Group was far from easy. Their journey proves that with unwavering determination, every step no matter how challenging is a step toward success.
                    <br />
                    Their first step was launching Kapra Highness Ventures Limited, a parent company that would oversee various ventures. They understood that to create something meaningful, they needed to diversify, which led to the birth of Sellerzkart Digital Commerce Pvt Ltd , Kapra Buyerzkart Digital Commerce Pvt. Ltd Kapra Daily , Kapra Gold & Diamonds, and Kapra WebAI.
                    <br />
                    Their determination and commitment fueled their efforts, and slowly but surely, people began to embrace the services of Kapra Group.
                    <br />
                    Kapra Group Built on dreams, powered by hard work, and driven by a passion for change.
                </p>
            </div>
        </section>
    );
};

export default About;
